import React from "react";
import { Pie } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
const ChartPie = ({ genderStatistics, height, width }) => {
   const maleCount = genderStatistics?.maleCount || 0;
   const femaleCount = genderStatistics?.femaleCount || 0;
   const { t } = useTranslation(); // ✅ hook
   const data = {
      datasets: [
         {
            data: [maleCount, femaleCount],
            borderWidth: 2,
            backgroundColor: ["#3b4cb8", "rgba(89, 59, 219, 0.7)"],
            hoverBackgroundColor: ["#2a3a9a", "rgba(89, 59, 219, 0.9)"],
         },
      ],
      labels: [t("Male"), t("Female")],
   };

   const options = {
      responsive: true,
      maintainAspectRatio: false, // ✅ Important: allows custom height
      legend: {
         display: true,
         position: 'bottom',
         labels: {
            fontSize: 14, // ✅ Increase legend font size
            padding: 15
         }
      },
      tooltips: {
         callbacks: {
            label: function (tooltipItem, data) {
               const dataset = data.datasets[tooltipItem.datasetIndex];
               const currentValue = dataset.data[tooltipItem.index];
               const label = data.labels[tooltipItem.index];
               const total = maleCount + femaleCount;
               const percentage = total > 0 ? ((currentValue / total) * 100).toFixed(2) : 0;
               return `${label}: ${currentValue} (${percentage}%)`;
            }
         }
      }
   };

   return (
      <div style={{ height: '100%', width: '100%' }}> {/* ✅ Fill container */}
         <Pie
            data={data}
            options={options}
            height={height || null}
            width={width || null}
         />
      </div>
   );
};

export default ChartPie;